import React from 'react'
import './Header.css'

function Header() {
    return(
        <div className="header">
            <div className="title">
                Our Amazing World
            </div>
            <div className="self">
                Tim Calhoun
            </div>
        </div>
    )
}

export default Header;